import {isPhone, isHKPhone, loginConfirm,sendCode} from "../../js/axios";

export default {
    name: 'login',
    data() {
        return {
            windowHeight: 0,
            errorTip: false,
            checked: false,
            phone:  '',
            password:  '',
			mobile:"",
			code:"",
            terms: false,
            tipStatus: "",
            tipText: "",
            alertShow: false,
			mainHeights:'',
            errorMessage:'',
			countDown:60,
				loginYzmJt:false,
				loginhqyzm:'获取验证码',
				sending: false ,// 正在发送验证码
				codeTimer:0,
				loa:852
        }
    },
    created() {
        this.windowHeight = document.documentElement.clientHeight;
        localStorage.clear();
    },
	beforeDestroy(){
		clearTimeout(this.codeTimer)
	},
    methods: {
		isPhone(phone){
			if (this.loa == 852) {
				return isHKPhone(phone)
			}
			return isPhone(phone)
		},
		clearFormErr(){
			this.errorMessage = ""
		},
        confirmDialog(){
            this.alertShow=false;
        },
        closeDialog(){
            this.alertShow=false;
            if(this.$store.state.isLogin){
                this.$router.push({path: '/menu'});
            }
        },
		sendCode(){
			if(this.checked == false){
				this.errorMessage="請閲讀並同意協議";
				return;
			}
			if (this.phone == '') {
			    this.errorMessage="請輸入賬號名";
			    return;
			}
			if (this.password == '') {
			    this.errorMessage="請輸入密碼";
			    return;
			}
			if(this.mobile == ""){
				this.errorMessage="請輸入手机号";
				return;
			}
			if(!this.isPhone(this.mobile)){
				this.errorMessage="手机号码格式不正确，請重新輸入";
				return;
			}
			this.formError=''
			
			const data = {
				country_code :this.loa,
				mobile:this.mobile
			}
			
			sendCode(data).then(res => {
				console.log("res",res);
				if (res.code == 200) {
					this.startTimer()
				} else{
					
				}
			})
			
		},
		startTimer(){
			this.sending = true;
			this.countDown = 60
			this.codeTimer = setInterval(() => {
				if(this.countDown > 0){
					--this.countDown;
				}else{
					clearInterval(this.codeTimer);
					this.sending = false;
				}
			},1000);
			this.loginhqyzm='重新发送';
			this.formDx='短信验证码已发送，可能会有延后，请耐心等待';
		},
        loginBtn() {
            if (this.phone == '') {
                this.errorMessage="請輸入賬號名";
                return;
            }
            if (this.password == '') {
                this.errorMessage="請輸入密碼";
                return;
            }
			// if(this.mobile == ""){
			// 	this.errorMessage="請輸入手机号";
			// 	return;
			// }
			// if(!this.isPhone(this.mobile)){
			// 	this.errorMessage="手机号码格式不正确，請重新輸入";
			// 	return;
			// }
			// if(this.code == ""){
			// 	this.errorMessage="請輸入验证码";
			// 	return;
			// }
            if (!this.checked) {
                this.errorMessage="請閲讀並同意協議";
                return;
            }
            let data = {
                account: this.phone,
                password: this.password,
				// code :this.code ,
				// country_code :this.loa,
				// mobile:this.mobile
            };
			
			
            loginConfirm(data).then((res) => {
                if (res.code == 200) {
                    let listData = JSON.parse(window.atob(res.data));
                    this.$store.dispatch('login', true).then(() => {
                        this.errorMessage="";
						localStorage.setItem("userInfo",JSON.stringify(listData))
                        if(this.$store.state.isLogin){
                            localStorage.setItem("access_token",listData.access_token);
                            this.$router.push({path: '/menu'});
                        }
                    });
                } else {
                    this.errorMessage=res.msg;
                }
            });
        },
    }
}